export default __webpack_public_path__ + "static/media/electron.0e836b9f.svg";